import { useRef, useEffect } from 'react';
import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
const SkillTemplate = ({ templateList, visible, onClose, setTemplate }) => {
    const templateRef = useRef();
    //点击弹窗以外的部分，关闭弹窗
    const clickGap = (e) => {
        //如果弹窗未打开，不做任何操作
        if (!templateRef.current) {
            return false;
        }
        //日期组件点击年份的时候，contains不生效，所以在wrapRef上阻止了冒泡
        if (templateRef.current && !templateRef.current.contains(e.target)) {
            onClose();
        }
    };
    useEffect(() => {
        document.body.addEventListener('click', clickGap);
        return () => {
            document.body.removeEventListener('click', clickGap);
        };
    }, []);
    return (
        <>
            <Display show={visible}>
                <div ref={templateRef} className={s['template-box']}>
                    <div className={s['mask-wrap']}>
                        {/* <div className={s['mask-title']}>
                            <span className={s['close']} onClick={onClose}>
                                <MyIcon type="icon-a-guanbi31"></MyIcon>
                            </span>
                        </div> */}
                        <div className={s['mask-list-box']}>
                            {templateList &&
                                templateList.map((item, index) => {
                                    return (
                                        <div className={s['mask-list-item']} key={index} onClick={() => setTemplate(item.template_content)}>
                                            <div className={s['template-name']}>{item.template_name}</div>
                                            <div className={s['template-describe']}>{item.template_describe}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </Display>
        </>
    );
};

export default SkillTemplate;
